var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n    "+_vm._s(_vm.errors)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }